import { Maybe, SurveyQuestion } from "gql/generated";
import { SurveyQuestionList } from "shared/components";
import { useBookerContext } from "widgets/booker/contexts";

type QuestionnaireQuestionListProps = {
  questions: SurveyQuestion[];
  getResponse: (question: SurveyQuestion) => string[] | Maybe<string>[];
  onResponseChange: (questionId: string, response: string[]) => void;
};

export const QuestionnaireQuestionList = (
  props: QuestionnaireQuestionListProps,
) => {
  const { language } = useBookerContext();
  return <SurveyQuestionList {...props} language={language} />;
};
